import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const HouseSystem = () => {
    useEffect(() => {
        document.title = 'House System -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>  
                <li>The Almanac</li>
                 <li>House System</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>House System </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12"> 
                 <p>To create a sense of belongingness and cultivate feelings of loyalty students of the senior school are divided into following House:</p>
                 <div className="qoutes"><p>Subroto, Arjan, Pratap, Latif and Katre</p></div>

                 <ul className="list"> 
                   <li> Each house has a house warden who along with a team of house tutors prepares students for IHA (Inter-House Activities) </li>
                   <li>A large number of Inter-House activities are planned for Academic Session. </li>
                   <li>The house T-shirt is to be worn by the students every Thursday for House Assembly and when they participate in IHA. </li>
                   <li>The House on duty will maintain the display board for a month. </li>
                   <li>Points will be awarded to each House of each IHA. </li>
                   
                   </ul>
                {/*  <div className="table-responsive maintable">
                <table className="table">
                   <thead>
                          <tr align="center"> 
                           <th colspan="3">    HOUSE ON DUTY: 2019-20</th> 
                         </tr>
                   </thead>
                     <tbody> 
                     <tr> <td> ARJAN </td> <td> April </td> <td> October </td> </tr> <tr> <td> KATRE </td> <td> May </td> <td> November </td> </tr> <tr> <td> LATIF </td> <td> July </td> <td> December </td> </tr> <tr> <td>   PRATAP </td> <td> August </td> <td> January </td> </tr> <tr> <td> SUBROTO </td> <td> September </td> <td> February </td> </tr>
                     </tbody>
                </table>
                </div>   */}
         
                </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default HouseSystem